import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { portalCopy } from '../copy';
import { PortalButton, PortalField, portalInputClass } from '../components/PortalUi';
import { usePartnerAuth } from '../context/PartnerAuthContext';

const PartnerLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { user, loginWithPassword } = usePartnerAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [authError, setAuthError] = useState(false);
  const [loading, setLoading] = useState(false);

  if (user) {
    return <Navigate to="/partners/panel" replace />;
  }

  const handleLogin = async () => {
    setLoading(true);
    setAuthError(false);

    const ok = await loginWithPassword(email, password);
    setLoading(false);

    if (ok) {
      navigate('/partners/panel');
      return;
    }

    setAuthError(true);
  };

  const canSubmit = email.trim().length > 0 && password.length > 0 && !loading;

  return (
    <div className="min-h-screen bg-[#fcf7fa] px-5 py-10 font-jakarta text-[#2a0f2a] antialiased sm:px-8">
      <div className="mx-auto max-w-md">
        <div className="text-center">
          <h1 className="font-instrument text-4xl italic tracking-[-0.02em] text-[#2a0f2a] sm:text-5xl">
            {portalCopy.login.title}
          </h1>
          <p className="mt-3 font-jakarta text-[15px] leading-relaxed text-[#5a3158]">
            {portalCopy.login.subtitle}
          </p>
        </div>

        <div className="mt-10 space-y-4 rounded-[24px] border border-[rgba(74,33,71,0.1)] bg-white p-6">
          <PortalField label={portalCopy.login.emailLabel} htmlFor="partner-email">
            <input
              id="partner-email"
              type="email"
              autoComplete="username"
              className={portalInputClass}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setAuthError(false);
              }}
              placeholder={portalCopy.login.emailPlaceholder}
            />
          </PortalField>

          <PortalField label={portalCopy.login.passwordLabel} htmlFor="partner-password">
            <input
              id="partner-password"
              type="password"
              autoComplete="current-password"
              className={portalInputClass}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setAuthError(false);
              }}
              placeholder={portalCopy.login.passwordPlaceholder}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && canSubmit) {
                  void handleLogin();
                }
              }}
            />
          </PortalField>

          {authError && (
            <p className="rounded-2xl bg-red-50 px-4 py-3 text-center font-jakarta text-sm text-red-700">
              {portalCopy.login.invalidCredentials}
            </p>
          )}

          <PortalButton fullWidth disabled={!canSubmit} onClick={() => void handleLogin()}>
            {loading ? 'Entrando…' : portalCopy.login.submit}
          </PortalButton>
        </div>
      </div>
    </div>
  );
};

export default PartnerLoginPage;
